// @ts-nocheck
import { useEffect, useState } from 'react';
import axios from 'axios';
import utils from '../../utils/utils';
import useConsole from '../Console/useConsole';
import useDatasetGrid from '../useDatasetGrid';
import ApiEndpoints from '../../const/ApiEndpoints';
import useProject from '../Project/useProject';
import MODULE_SUB_MODULE_OPERATIONS_TREE from '../../const/ModuleSubModuleOperationsTree';
import { DATASET_REQUIRED_FIELDS } from '../../const/CommonConst';
import useModelMetaData from '../useModelMetaData';
import useDataIngestion from '../DM/useDataIngestion';

const BASE_URL = ApiEndpoints.MODULE_BASE_URL.VR;
const { BASE_URL_TS } = ApiEndpoints.MODULE_BASE_URL;
const totalPageCount = 'x-total-count';

/**
 * @function useVariableReduction
 * @description A Variable Reduction Hook
 * @returns {object} -returning multiple methods and states for variable reduction module
 * @example const {analyse,
embeddedValues,
standardisationError,
integrityRules,
uniqueness,
scores,
fetchGridTaskData }=useVariableReduction()
 */
export default function useVariableReduction() {
  const {
    fetchModuleTasks,
    datasetList,
    fetchDatasetList,
    fetchDatasetRowsWithPagination,
    datasetRowsWithPagination,
    setDatasetRowsWithPagination,
    totalDatasetRows,
    datasetRowsPageCount,
    isLoading,

    updateDatasetCells,
    project,
  } = useProject();

  const {
    renameColumn,
    deleteColumn,
    duplicateColumn,
    addColumn,
    deleteRow,
    duplicateRow,
    addRow,
    tasks: gridTasks,
    taskCount: gridTaskCount,
    fetchTasks: fetchGridTasks,
    terminateTask: terminateGridTask,
    manageSpaces,
    manageCases,
    splitColumn,
    findAndReplace,
    sortColumn,
    analyse,
    embeddedValues,
    standardisationError,
    integrityRules,
    uniqueness,
    scores,
    fetchGridTaskData,
    findDuplicateRows,
    findDuplicateColumns,
    findAndDeleteDuplicateRows,
    findAndDeleteDuplicateColumns,
    setGridTaskResultsData,
    gridTaskResultsData,
    resetGridTaskResultsData,
    markTaskReadUnreadGrid,
    valueError,
    findBlankValuePercentage,
    replaceBlankValues,
    findRegexPercentage,
    gridOperationRerun,
  } = useDatasetGrid();

  const {
    consoleModuleTasks,
    setConsoleModuleTasks,
    consoleAsyncTaskResults,
    fetchAsyncResultConsole,
    terminateTaskConsole,
    markTaskReadUnreadConsole,
    fetchModuleTasksConsole,
    fetchUdfs,
    deleteUdf,
    createUdf,
    createJob,
    updateUdf,
    udfs,
    selectedUdf,
    setSelectedUdf,
    runUdf,
    githubIntegration,
    fetchUdfDetails,
    fetchDatasetColumnDetailsForConsole,
    setConsoleAsyncTaskResults,
    fetchAllModels,
    fetchTableData,
    onDownloadCSV,
    fetchConsoleLibraries,
    consoleRerunOperation,
    fetchConsoleFileList,
  } = useConsole();
  const { markDatasetAsReadyToUse } = useDataIngestion();

  const { addResultToModelMetaData, fetchModelMetaDataSchema } =
    useModelMetaData();

  const [activeDataset, setActiveDataset] = useState('');
  // For Column Details of Active Dataset
  useEffect(() => {
    if (activeDataset?.id) {
      datasetList?.forEach((data) => {
        if (data.id === activeDataset.id) {
          setActiveDataset(data);
        }
      });
    }
  }, [datasetList]);
  const [activeOperation, setActiveOperation] = useState(
    MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.operations.MV
  );

  const [datasetColumnDetails, setDatasetColumnDetails] = useState([]);

  const [moduleTasks, setModuleTasks] = useState([]);
  const [totalModuleTask, setTotalModuleTask] = useState(0);
  const [totalModuleTaskConsole, setTotalModuleTaskConsole] = useState(0);
  const [taskCount, setTaskCount] = useState({});

  const [taskDetails, updateTaskDetails] = useState({});
  const [targetVariables, setTargetVariables] = useState([]);
  const [variableFinalisation, setvariableFinalisation] = useState({});
  const resetTaskDetails = () => {
    updateTaskDetails({});
  };
  const [missingDatasetColumn, setMissingDatasetColumn] = useState([]);

  const fetchMissingDatasetColumnDetails = (datasetName) =>
    axios
      .post(
        `${
          ApiEndpoints.MODULE_BASE_URL.EDA +
          ApiEndpoints.EDA.EDA_MVI_GET_COLUMNS
        }`,
        datasetName
      )
      .then(
        (res) => {
          setMissingDatasetColumn(res?.data?.Columnlist);
          return res;
        },
        (error) => {
          throw error;
        }
      );

  /**
   * @function fetchVRModuleTasksConsole
   * @description API call for fetching data quality module tasks
   * @param {number} projectId - module tasks of a particular project id
   * @param {boolean} hideLoaderOnRequest -hiding loader on request
   * @returns {undefined}
   * @example fetchDQModuleTasks(project_id,hideLoaderOnRequest);
   */
  const fetchVRModuleTasksConsole = (
    projectId,
    hideLoaderOnRequest,
    pageIndex,
    pageSize,
    taskStatus
  ) => {
    if (projectId) {
      fetchModuleTasksConsole(
        MODULE_SUB_MODULE_OPERATIONS_TREE.VR.objKey,
        MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.key,
        'GET_VR_TASKS',
        projectId,
        hideLoaderOnRequest,
        pageIndex,
        pageSize,
        taskStatus
      ).then((res) => {
        if (res.data) {
          setTotalModuleTaskConsole(res.headers[totalPageCount]);
          if (pageIndex > 1) {
            setConsoleModuleTasks([...consoleModuleTasks, ...res.data]);
          } else {
            setConsoleModuleTasks([...res.data]);
          }
        }
      });
    }
  };

  const fetchPSModuleTasks = (
    projectId,
    hideLoaderOnRequest,
    pageIndex,
    pageSize,
    taskStatus
  ) => {
    if (projectId) {
      return fetchModuleTasks(
        MODULE_SUB_MODULE_OPERATIONS_TREE.VR.objKey,
        MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.key,
        'GET_VR_TASKS',
        () => {},
        projectId,
        hideLoaderOnRequest,
        '',
        pageIndex,
        pageSize,
        taskStatus
      ).then((res) => {
        if (res.data) {
          setTotalModuleTask(res.headers?.[totalPageCount]);
          if (pageIndex > 1) {
            setModuleTasks((prevModuleTasks) => [
              ...prevModuleTasks,
              ...(res?.data?.tasks || []),
            ]);
          } else {
            setModuleTasks([...res.data.tasks]);
          }
        }
        return res;
      });
    }
  };

  /**
   * Fetch Async Result Data on the basis of type of result.
   *
   * @param {string} taskID - The ID of the task.
   * @param {number} type - The type of data we can result for.
   * @return {Promise} It returns an object which contains task result details.
   */
  const fetchAsyncResultSplit = (taskID, type) =>
    axios
      .get(`${`${BASE_URL + ApiEndpoints.VR.GET_VR_TASKS}/${taskID}/${type}`}/`)
      .then((res) => {
        return res;
      });

  /**
   * Fetches the count of module tasks.
   *
   * @param {string} projectId - The ID of the project.
   * @param {boolean} hideLoaderOnRequest - Whether to hide the loader on request.
   * @param {number} count - The count of tasks to fetch.
   * @return {Promise} A promise that resolves with the count of tasks.
   */
  const fetchModuleTasksCount = (projectId, hideLoaderOnRequest, count) => {
    if (projectId) {
      fetchModuleTasks(
        MODULE_SUB_MODULE_OPERATIONS_TREE.VR.objKey,
        MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.key,
        'GET_VR_TASKS',
        () => {},
        projectId,
        hideLoaderOnRequest,
        '',
        null,
        null,
        null,
        count
      ).then((res) => {
        setTaskCount(res?.data);
      });
    }
  };

  /**
   * @function fetchDatasetColumnDetails
   * @description For fetching Active Dataset Columns
   * @param {object} datasetName - table name
   * @returns {Promise} AxiosPromise
   * @example fetchDatasetColumnDetails(datasetName);
   */
  const fetchDatasetColumnDetails = (datasetName) =>
    axios
      .post(
        `${
          ApiEndpoints.MODULE_BASE_URL.VR +
          ApiEndpoints.VR.DATASET_COLUMN_DETAILS
        }`,
        datasetName
      )
      .then(
        (res) => {
          setDatasetColumnDetails(res.data?.columns);
        },
        () => {}
      );
  /**
   * @function fetchMissingValueData
   * @description For fetching details if the dataset containing any missing value.
   * @param {object} body - object containing table name and project id.
   * @param {function} successCallback - Callback function to execute upon completion of API call
   * @returns {Promise} AxiosPromise
   * @example fetchMissingValueData(body,successCallback);
   */

  const fetchMissingValueData = (body, successCallback) =>
    axios
      .post(`${BASE_URL + ApiEndpoints.VR.VR_MISSING_VALUE_CHECK}`, body)
      .then(
        (res) => {
          successCallback(res);
        },
        () => {}
      );

  /**
   * @function fetchClustringData
   * @description For fetching details if the dataset containing any missing value.
   * @param {object} body - object containing table name and project id.
   * @param {function} successCallback - Callback function to execute upon completion of API call
   * @returns {Promise} AxiosPromise
   * @example fetchClustringData(body);
   */
  const fetchClustringData = (body, successCallback) =>
    axios.post(`${BASE_URL + ApiEndpoints.VR.VR_CLUSTRING_CHECK}`, body).then(
      (res) => {
        successCallback(res);
      },
      () => {}
    );

  /**
   * @function fetchTargetVariableList
   * @description For fetching target variables list
   * @param {object} body - table name
   * @returns {Promise} AxiosPromise
   * @example fetchTargetVariableList(body);
   */
  const fetchTargetVariableList = (body) => {
    axios.post(`${BASE_URL + ApiEndpoints.VR.GET_TARGET_LIST}`, body).then(
      (res) => {
        setTargetVariables(res.data.valid_targets);
      },
      () => {
        setTargetVariables([]);
      }
    );
  };
  /**
   * @function fetchAsyncResult
   * @description For fetching result of a task ID
   * @param {object} taskID - TASK ID
   * @param {function} successCallback - Callback function to execute upon completion of API call
   * @param {function} additionTaskDetails - task details of being created
   * @returns {Promise} AxiosPromise
   * @example fetchAsyncResult(taskID, additionTaskDetails, successCallback);
   */

  const fetchAsyncResult = (taskID, additionTaskDetails, successCallback) =>
    axios
      .get(`${`${BASE_URL + ApiEndpoints.VR.GET_VR_TASKS}/${taskID}`}`)
      .then((res) => {
        if (res.data.task_status === 'SUCCESS') {
          Object.values(
            MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.operations
          ).filter((data) => {
            if (data.key === additionTaskDetails.operation) {
              if (res.data?.parameters?.dataset_id) {
                datasetList?.forEach((dataset) => {
                  if (dataset.id === Number(res.data.parameters.dataset_id)) {
                    setActiveDataset(dataset);
                  }
                });
              }
              updateTaskDetails(res.data);
              setActiveOperation(data);
              // eslint-disable-next-line no-unused-expressions
              res.data?.results === undefined ||
              Array.isArray(res.data?.results) ||
              res.data?.results?.msg ||
              res.data?.results?.is_grid
                ? successCallback(2, res.data)
                : successCallback(0, res.data);
            }
            return null;
          });
        } else {
          updateTaskDetails({});
        }
      });

  /**
   * @function fetchAsyncResultConsoleAndActivateDataset
   * @description API call for fetching asynchronous result
   * @param {number}  taskID - task id
   * @param {object}  additionTaskDetails - addition task details
   * @returns  {Promise} AxiosPromise
   * @example  fetchAsyncResultConsoleAndActivateDataset(taskID, additionTaskDetails)
   */
  const fetchAsyncResultConsoleAndActivateDataset = (
    taskID,
    additionTaskDetails
  ) =>
    fetchAsyncResultConsole(taskID, additionTaskDetails).then(
      (res) => {
        if (res.data.task_status === 'SUCCESS') {
          if (utils.isNewDatasetCreatedByUdf(res.data)) {
            fetchDatasetList(
              project?.activeProject?.project_id,
              true,
              [DATASET_REQUIRED_FIELDS].join()
            );
          }
          if (res.data?.parameters?.table) {
            datasetList?.forEach((dataset) => {
              if (dataset.Name === res.data.parameters.table) {
                setActiveDataset({ ...dataset });
              }
            });
          }
        }
        return res;
      },
      (error) => {
        throw error;
      }
    );

  /**

  /**
 * @function terminateTask
 * @description For terminating a task
 * @param {string} taskID - TASK ID
 * @param {function} successCallback - Callback function to execute upon completion of API call
 * @param {function} errorCallback - Callback function to execute when any -
 * error happens during the calling of API
 * @returns {Promise} AxiosPromise
 * @example terminateTask(taskID, additionTaskDetails, successCallback);
*/
  const terminateTask = (taskID) =>
    axios
      .delete(`${`${BASE_URL + ApiEndpoints.VR.GET_VR_TASKS}/${taskID}`}`)
      .then((res) => {
        return res;
      })
      .catch((e) => {
        throw e;
      });

  /**
   * @function vrRerunOperation
   * @description API call for reruning the operation
   * @param {object} body - body
   * @returns {Promise} AxiosPromise
   * @example vrRerunOperation(body);
   */
  const vrRerunOperation = (body) => {
    return axios
      .post(`${BASE_URL + ApiEndpoints.VR.RERUN}`, body)
      .then((res) => {
        return res;
      })
      .catch((e) => {
        throw e;
      });
  };

  /**
* @function fetchColumnSummaryStats
* @description For fetching result of a task ID
* @param {object} body - body
* @param {function} successCallback - Callback function to execute upon completion of API call
* @param {function} errorCallback - Callback function to execute-
 when any error happens during the calling of API
* @returns {Promise} AxiosPromise
* @example fetchColumnSummaryStats(body, additionTaskDetails, successCallback);
*/
  const fetchColumnSummaryStats = (body, successCallback, errorCallback) =>
    axios.post(`${BASE_URL + ApiEndpoints.VR.PS_SUMMARY_STATS}`, body).then(
      () => {
        successCallback();
      },
      (error) => {
        errorCallback(error);
      }
    );
  /**
* @function fetchingDatasetSummaryStats
* @description For fetching Datasets of summary statistics
* @param {object} body - body
* @param {function} successCallback - Callback function to execute upon completion of API call
* @param {function} errorCallback - Callback function to execute-
 when any error happens during the calling of API
* @returns {Promise} AxiosPromise
* @example fetchingDatasetSummaryStats(body,successCallback,errorCallback);
*/
  const fetchingDatasetSummaryStats = (body, successCallback, errorCallback) =>
    axios.post(`${BASE_URL + ApiEndpoints.VR.PS_OVERALL_STATS}`, body).then(
      () => {
        successCallback();
      },
      (error) => {
        errorCallback(error);
      }
    );

  /**
   * @function missingValuesSubmit
   * @description To execute missing value task
   * @param {object} body - body
   * @param {function} successCallback - Callback function to execute upon completion of API call
   * @returns {Promise} AxiosPromise
   * @example missingValuesSubmit(body,successCallback);
   */

  const missingValuesSubmit = (body, successCallback) => {
    axios.post(`${BASE_URL + ApiEndpoints.VR.VR_OP_MISSING_VALUES}`, body).then(
      () => {
        successCallback();
      },
      (error) => {
        throw error;
      }
    );
  };
  /**
   * @function randomForestSubmit
   * @description To execute random Forest task
   * @param {object} body - body
   * @param {function} successCallback - Callback function to execute upon completion of API call
   * @returns {Promise} AxiosPromise
   * @example randomForestSubmit(body, successCallback);
   */
  const randomForestSubmit = (body, successCallback) =>
    axios.post(`${BASE_URL + ApiEndpoints.VR.VR_OP_RANDOM_FOREST}`, body).then(
      () => {
        successCallback();
      },
      (error) => {
        throw error;
      }
    );

  /**
   * @function lowVarianceSubmit
   * @description To execute low variance task
   * @param {object} body - body
   * @param {function} successCallback - Callback function to execute upon completion of API call
   * @returns {Promise} AxiosPromise
   * @example lowVarianceSubmit(body, successCallback);
   */
  const lowVarianceSubmit = (body, successCallback) =>
    axios.post(`${BASE_URL + ApiEndpoints.VR.VR_OP_LOW_VARIANCE}`, body).then(
      () => {
        successCallback();
      },
      (error) => {
        throw error;
      }
    );

  /**
* @function highCorrelationSubmit
* @description To execute high correlational task
* @param {object} body - body
* @param {function} successCallback - Callback function to execute upon completion of API call
* @param {function} errorCallback - Callback function to execute-
 when any error happens during the calling of API
* @returns {Promise} AxiosPromise
* @example highCorrelationSubmit(body,successCallback,errorCallback);
*/
  const highCorrelationSubmit = (body, successCallback) => {
    axios
      .post(`${BASE_URL + ApiEndpoints.VR.VR_OP_HIGH_CORRELATION}`, body)
      .then(() => {
        successCallback();
      });
  };
  /**
   * @function backwardFeatureSelectionSubmit
   * @description To execute backward feature selection task
   * @param {object} body - body
   * @param {function} successCallback - Callback function to execute upon completion of API call
   * @returns {Promise} AxiosPromise
   * @example backwardFeatureSelectionSubmit(body, successCallback,errorCallback);
   */
  const backwardFeatureSelectionSubmit = (body, successCallback) => {
    axios
      .post(
        `${BASE_URL + ApiEndpoints.VR.VR_OP_BACKWARD_FEATURE_SELECTION}`,
        body
      )
      .then(() => {
        successCallback();
      });
  };
  /**
   * @function forwardFeatureSelectionSubmit
   * @description To execute forward feature selection task
   * @param {object} body - body
   * @param {function} successCallback - Callback function to execute upon completion of API call
   * @returns {Promise} AxiosPromise
   * @example forwardFeatureSelectionSubmit(body, additionTaskDetails, successCallback);
   */
  const forwardFeatureSelectionSubmit = (body, successCallback) => {
    axios
      .post(
        `${BASE_URL + ApiEndpoints.VR.VR_OP_FORWARD_FEATURE_SELECTION}`,
        body
      )
      .then(
        () => {
          successCallback();
        },
        (error) => {
          throw error;
        }
      );
  };

  /**
* @function clusteringSubmit
* @description To execute clustering task
* @param {object} body - body
* @param {function} successCallback - Callback function to execute upon completion of API call

* @returns {Promise} AxiosPromise
* @example clusteringSubmit(body, successCallback);
*/
  const clusteringSubmit = (body, successCallback) =>
    axios.post(`${BASE_URL + ApiEndpoints.VR.VR_OP_CLUSTERING}`, body).then(
      () => {
        successCallback();
      },
      (error) => {
        throw error;
      }
    );
  /**
* @function pcaSubmit
* @description To execute pca task
* @param {object} body - body
* @param {function} successCallback - Callback function to execute upon completion of API call
* @param {function} errorCallback - Callback function to execute when-
 any error happens during the calling of API
* @returns {Promise} AxiosPromise
* @example pcaSubmit(body, additionTaskDetails, successCallback);
*/
  const pcaSubmit = (body) =>
    axios
      .post(
        `${BASE_URL + ApiEndpoints.VR.VR_OP_PRINCIPAL_COMPONENT_ANALYSIS}`,
        body
      )
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        throw error;
      });

  /**
* @function ivValuesSubmit
* @description To execute IV values task
* @param {object} body - body
* @param {function} successCallback - Callback function to execute upon completion of API call

* @returns {Promise} AxiosPromise
* @example ivValuesSubmit(body, successCallback);
*/
  const ivValuesSubmit = (body, successCallback) =>
    axios.post(`${BASE_URL + ApiEndpoints.VR.VR_OP_IV_VALUES}`, body).then(
      () => {
        successCallback();
      },
      (error) => {
        throw error;
      }
    );

  /**
* @function lassoFeatureSelectionSubmit
* @description To execute lasso of feature selection task
* @param {object} body - body
* @param {function} successCallback - Callback function to execute upon completion of API call
* @param {function} errorCallback - Callback function to execute-
 when any error happens during the calling of API
* @returns {Promise} AxiosPromise
* @example lassoFeatureSelectionSubmit(body, successCallback,errorCallback);
*/
  const lassoFeatureSelectionSubmit = (body, successCallback) =>
    axios.post(`${BASE_URL + ApiEndpoints.VR.VR_TS_LASSO}`, body).then(() => {
      successCallback();
    });

  /**
* @function ridgeFeatureSelectionSubmit
* @description To execute Ridge feature selection task
* @param {object} body - body
* @param {function} successCallback - Callback function to execute upon completion of API call
* @param {function} errorCallback - Callback function to-
 execute when any error happens during the calling of API
* @returns {Promise} AxiosPromise
* @example ridgeFeatureSelectionSubmit(body, successCallback,errorCallback);
*/
  const ridgeFeatureSelectionSubmit = (body, successCallback) =>
    axios.post(`${BASE_URL + ApiEndpoints.VR.VR_TS_RIDGE}`, body).then(() => {
      successCallback();
    });

  /**
* @function stepwiseFeatureSelectionSubmit
* @description To execute stepwise feature selection task
* @param {object} body - body
* @param {function} successCallback - Callback function to execute upon completion of API call
* @param {function} errorCallback - Callback function to execute-
 when any error happens during the calling of API
* @returns {Promise} AxiosPromise
* @example stepwiseFeatureSelectionSubmit(body,successCallback,errorCallback);
*/
  const stepwiseFeatureSelectionSubmit = (body, successCallback) => {
    axios
      .post(`${BASE_URL + ApiEndpoints.VR.VR_OP_STEP_WISE_SELECTION}`, body)
      .then(() => {
        successCallback();
      });
  };

  /**
   * @function fetchVariableFinalisation
   * @description To execute Variable Finalization task
   * @param {number} activeDatasetId - activeDatasetId
   * @returns {Promise} AxiosPromise
   * @example fetchVariableFinalisation(activeDatasetId);
   */
  const fetchVariableFinalisation = (activeDatasetId) => {
    setvariableFinalisation({});
    return axios
      .get(`${BASE_URL + ApiEndpoints.VR.VR_OP_VARIABLE_FINALISATION}`, {
        params: {
          dataset_id: activeDatasetId || activeDataset.id,
          project_id: project.activeProject.project_id,
        },
      })
      .then((res) => {
        setvariableFinalisation(
          res.data?.length
            ? res.data.filter((col) => col.column_name !== 'pk')
            : []
        );
        return res;
      })
      .catch((e) => {
        throw e;
      });
  };

  /**
* @function sendVariableFinalisation
* @description To execute Variable Finalization task
* @param {object} body - activeDataset
* @param {function} successCallback - Callback function to execute upon completion of API call
* @param {function} errorCallback - Callback function to execute-
 when any error happens during the calling of API
* @returns {Promise} AxiosPromise
* @example sendVariableFinalisation(body, successCallback,errorCallback);
*/
  const sendVariableFinalisation = (
    body,
    successCallback = () => {},
    errorCallback = () => {}
  ) =>
    axios
      .post(`${BASE_URL + ApiEndpoints.VR.VR_OP_VARIABLE_FINALISATION}`, {
        project_id: project.activeProject.project_id,
        ...body,
      })
      .then(
        (res) => {
          successCallback();
          setvariableFinalisation(
            res.data?.length
              ? res.data.filter((col) => col.column_name !== 'pk')
              : []
          );
        },
        (error) => {
          errorCallback(error);
        }
      );

  /**
* @function finalSubmit
* @description payload of Rejected columns
* @param {object} body - body
* @param {function} successCallback - Callback function to execute upon completion of API call

* @returns {Promise} AxiosPromise
* @example finalSubmit(body, successCallback);
*/
  const finalSubmit = (body, successCallback = () => {}) =>
    axios.post(`${BASE_URL + ApiEndpoints.VR.VR_OP_FINAL_SUBMIT}`, body).then(
      () => {
        successCallback();
      },
      (error) => {
        throw error;
      }
    );

  /**
* @function markTaskReadUnreadVariableReduction
* @description To mark task as unread & read variable reduction
* @param {object} taskParams - taskParams
* @param {function} successCallback - Callback function to execute upon completion of API call

* @returns {Promise} AxiosPromise
* @example markTaskReadUnreadVariableReduction(taskParams, successCallback);
*/
  const markTaskReadUnreadVariableReduction = (taskParams, successCallback) =>
    axios
      .get(`${BASE_URL + ApiEndpoints.VR.VR_JOB_QUEUE_MARK_READ_UNREAD}`, {
        params: taskParams,
      })
      .then(
        () => {
          successCallback();
        },
        () => {}
      );

  /** 
  @function vrTsRerunOperation
  @description  To rerun the VR operation 
  @param {object} body - body
  @return {Promise} -AxiosPromise
  @example  vrTsRerunOperation(body);
*/

  const vrTsRerunOperation = (body) => {
    return axios
      .post(`${BASE_URL_TS + ApiEndpoints.VR.VR_TS_RERUN}`, body)
      .then((res) => {
        return res;
      })
      .catch((e) => {
        throw e;
      });
  };

  return {
    /**
     * The currently active operation within the Variable Reduction module.
     * @type {string}
     */
    activeOperation,
    /**
     * Function to set the currently active operation within the Variable Reduction module.
     * @function
     * @param {string} operationKey - The key of the operation to set as active.
     * @returns {void}
     */
    setActiveOperation,
    /**
     * The currently active dataset within the Variable Reduction module.
     * @type {Object}
     */
    activeDataset,
    /**
     * Function to set the currently active dataset within the Variable Reduction module.
     * @function
     * @param {Object} dataset - The dataset to set as active.
     * @returns {void}
     */
    setActiveDataset,

    vrTsRerunOperation,

    moduleTasks,
    setModuleTasks,
    totalModuleTask,
    fetchPSModuleTasks,
    taskCount,
    fetchModuleTasksCount,

    resetTaskDetails,
    taskDetails,

    fetchMissingDatasetColumnDetails,
    missingDatasetColumn,

    fetchAsyncResult,

    fetchColumnSummaryStats,

    fetchingDatasetSummaryStats,
    lowVarianceSubmit,
    missingValuesSubmit,
    randomForestSubmit,
    highCorrelationSubmit,
    backwardFeatureSelectionSubmit,
    forwardFeatureSelectionSubmit,
    fetchVariableFinalisation,
    sendVariableFinalisation,
    clusteringSubmit,
    pcaSubmit,
    ivValuesSubmit,
    variableFinalisation,
    setvariableFinalisation,
    finalSubmit,
    datasetList,
    terminateTask,
    fetchDatasetList,

    fetchDatasetRowsWithPagination,
    datasetRowsWithPagination,
    setDatasetRowsWithPagination,
    totalDatasetRows,
    datasetRowsPageCount,
    isLoading,
    fetchTargetVariableList,
    targetVariables,
    updateDatasetCells,
    renameColumn,
    duplicateColumn,
    deleteColumn,
    addColumn,
    deleteRow,
    duplicateRow,
    addRow,
    gridTasks,
    gridTaskCount,
    fetchGridTasks,
    terminateGridTask,
    manageSpaces,
    manageCases,
    splitColumn,
    findAndReplace,
    sortColumn,
    analyse,
    embeddedValues,
    standardisationError,
    integrityRules,
    uniqueness,
    scores,
    fetchGridTaskData,
    markTaskReadUnreadVariableReduction,
    vrRerunOperation,

    datasetColumnDetails,
    fetchDatasetColumnDetails,
    lassoFeatureSelectionSubmit,
    ridgeFeatureSelectionSubmit,
    stepwiseFeatureSelectionSubmit,
    fetchMissingValueData,
    fetchClustringData,
    findDuplicateRows,
    findDuplicateColumns,
    findAndDeleteDuplicateRows,
    findAndDeleteDuplicateColumns,
    setGridTaskResultsData,
    gridTaskResultsData,
    resetGridTaskResultsData,
    markTaskReadUnreadGrid,
    valueError,
    findBlankValuePercentage,
    replaceBlankValues,
    findRegexPercentage,
    gridOperationRerun,

    // console related
    consoleModuleTasks,
    totalModuleTaskConsole,
    consoleAsyncTaskResults,
    fetchAsyncResultConsoleAndActivateDataset,
    terminateTaskConsole,
    markTaskReadUnreadConsole,
    fetchVRModuleTasksConsole,
    fetchUdfs,
    deleteUdf,
    createUdf,
    createJob,
    updateUdf,
    udfs,
    selectedUdf,
    setSelectedUdf,
    runUdf,
    githubIntegration,
    fetchUdfDetails,
    fetchDatasetColumnDetailsForConsole,
    project,
    setConsoleAsyncTaskResults,
    fetchAllModels,
    fetchTableData,
    onDownloadCSV,
    fetchConsoleLibraries,
    consoleRerunOperation,
    markDatasetAsReadyToUse,
    fetchConsoleFileList,
    addResultToModelMetaData,
    fetchModelMetaDataSchema,
    fetchAsyncResultSplit,
  };
}
